import { tabsConfiguration } from '@/pages/estimation/detail/config';
import { Route } from '@/routes/estimation/detail/$estimationId/$tabId';

const EstimationDetailPage = () => {
  const { tabId: contentId = '' } = Route.useLoaderData();
  // $tabId's beforeLoad already rejects unknown tabs with notFound(), so this normally cannot
  // miss - but asserting here means any future route change lands as a crash rather than a 404.
  return tabsConfiguration.find((x) => x.tabId.toString() === contentId)?.content ?? null;
};

export default EstimationDetailPage;
